import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GetTemplatesNamesAndIdsDto, TemplateType } from '@modeso/types__aumico-lib-templates-be';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-ar-template-taxonomy-page',
    templateUrl: './ar-template-taxonomy.page.html',
    styleUrls: ['./ar-template-taxonomy.page.scss'],
})
export class ArTemplateTaxonomyPageComponent {
    @Input() taxonomyType: TemplateType;
    @Input() taxonomiesList: GetTemplatesNamesAndIdsDto[] = [];
    @Input() savedTaxonomyId: string;

    @Output() selectedTaxonomyId = new EventEmitter<string>();

    public onTaxonomySelected(templateId: string): void {
        this.selectedTaxonomyId.emit(templateId);
    }
}
